var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 10C20.4375 15.5228 15.9603 20 10.4375 20C4.91465 20 0.4375 15.5228 0.4375 10C0.4375 4.47715 4.91465 0 10.4375 0C15.9603 0 20.4375 4.47715 20.4375 10Z",
    fill: "#F5C980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 4V11.5H11.4375V4H9.4375Z",
    fill: "#54414B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 15C10.9898 15 11.4375 14.5523 11.4375 14C11.4375 13.4477 10.9898 13 10.4375 13C9.88521 13 9.4375 13.4477 9.4375 14C9.4375 14.5523 9.88521 15 10.4375 15Z",
    fill: "#54414B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrange);
export default __webpack_public_path__ + "static/media/IconOrange.a68a13866dbeeafb5f4d9bebd1a4a210.svg";
export { ForwardRef as ReactComponent };